import { useState, useEffect } from 'react';
import Form from './form/Form.component';
import Notification from '../interfaces/Notification';
import { INITIAL_VALUES } from '../utils/INITIAL_VALUES';
import { getByNotification, postFolowUp } from '../Notification.service';
import { useParams } from "react-router";
import { useHistory } from "react-router-dom";
import ParamTypes from '../../../core/interfaces/ParamTypes';
import { useSnackbar } from '../../../context/Snackbar';
import Progress from '../../../component/progress/Progress.component';
import { DisableRegistration } from '../../../core/interfaces/DisableRegistration';

export default function Register({ disabled }: DisableRegistration) {

    let history = useHistory();
    const { setSnackbar } = useSnackbar();
    let { id } = useParams<ParamTypes>();
    const [notification, setNotification] = useState<Notification>(INITIAL_VALUES);
    const [request, setRequest] = useState<boolean>(true);

    useEffect(() => {
        if (id) {
            getByNotification(Number(id)).then(res => {
                let response: Notification = res.data[0];
                response.affectedFlag = String(response.affectedFlag).split(',');
                response.type = '';
                setNotification(res.data[0])
            }).catch((error) => {
                console.log('Erro ao consultar notificação!', error);
            }).finally(() => {
                setRequest(false)
            });
        }
    }, [id]);

    const onSubmit = async (data: Notification) => {
        postFolowUp(data).then(res => {
            setSnackbar({ msg: `Notificação efetuada com sucesso!`, type: 'success' });
            history.push(`/notificacao/view-notificacao/${id}`);
        }).catch((error) => {
            console.log('Erro ao efetuar notificação!', error);
            setSnackbar({ msg: `Erro ao efetuar notificação`, type: 'error' });
        });
    };

    if (id && request) {
        return <Progress open={request} />
    }

    return (
        <Form handleSubmitForm={onSubmit} initialValues={notification} disabled={disabled} />
    );
}
